import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

/**
 * Effect-based redirect so navigating to `$appId` briefly mounts AppDetails
 * (with its loading Spinner) before moving to data-collection — matching the
 * old RR `<Redirect>` hop that click-through tests wait on.
 */
const AppIndexRedirect = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const { appId } = Route.useParams();

  useEffect(() => {
    navigate({
      to: '/administration/apps/$appId/data-collection',
      params: { appId },
      replace: true,
    });
  }, [appId, navigate]);

  return null;
};

export const Route = createFileRoute('/_secured/administration/apps/$appId/')({
  component: AppIndexRedirect,
});
